import { z } from "zod";

import {
    api_pkg_task_dto_OperationSchema,
    api_pkg_task_dto_PatchShiftEntitySchema,
} from "@sdk/schemas";
import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/planning").PATCH();

const patchPlanningReqSchema = z.array(
    api_pkg_task_dto_PatchShiftEntitySchema.extend({
        operation: api_pkg_task_dto_OperationSchema.optional(),
        id: z.string().optional(),
        recurrenceId: z.string().optional(),
        startDate: z.coerce.date(),
        endDate: z.coerce.date(),
        breakDuration: z.number(),
        slots: z.number(),
    }),
);

type PatchPlanningReq = z.infer<typeof patchPlanningReqSchema>;

export async function patchPlanning({
    params,
    req,
}: {
    params: typeof endpoint.types.P;
    req: PatchPlanningReq;
}) {
    const call = createCall({ ...endpoint, req: patchPlanningReqSchema }, (r) =>
        fetch(withAccountAuthHeaders(r)),
    );
    return await call({ params, req });
}
